import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		alignItems: 'center',
		backgroundColor: theme.palette.background.default,
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		justifyContent: 'center',
		minHeight: '100%',
		padding: theme.spacing(3),
		textAlign: 'center',
	},
}));

function Loading({ isLoading = true, component = LinearProgress, ...props }) {
	const classes = useStyles();
	const Component = component;

	return (
		<div className={classes.root} {...props}>
			<Box width={400}>
				<Component color="primary" />
			</Box>
		</div>
	);
}

Loading.propTypes = {
	isLoading: PropTypes.bool,
	component: PropTypes.oneOfType([
		PropTypes.element,
		PropTypes.node,
		PropTypes.object,
		PropTypes.func,
	]),
};

export default Loading;
